// extracted by mini-css-extract-plugin
export default {"root":"tQzi2IX2DxCI4qWZLfR1","readonly":"R7GD6434aOWFPQ1jqKOH","selectable":"bYK_OX6Q_yYHKuJ7bQxi","selected":"ZfMQwv_fBvoGeCK42Yhc"};